/* Viverdez Hero JS con Swiper Carousel
   - Inicialización de Swiper con configuraciones dinámicas
   - Lazy-load para iframes (YouTube/Vimeo)  
   - Efectos de transición y autoplay configurables
*/
(function(){
  function onReady(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  onReady(function(){
    // Esperar a que Swiper esté disponible
    function initializeSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initializeSwiper, 100);
        return;
      }

      document.querySelectorAll('.vv-hero').forEach(function(section){
        var swiperContainer = section.querySelector('.vv-hero-swiper');
        if (!swiperContainer) return;

        // Obtener configuraciones desde el script tag correspondiente a esta sección
        var scriptTag = section.querySelector('script[data-section-id]');
        var sectionId = scriptTag ? scriptTag.dataset.sectionId : 'default';
        var autoplay = scriptTag ? scriptTag.dataset.autoplay !== 'false' : true;
        var autoplaySpeed = scriptTag ? parseInt(scriptTag.dataset.autoplaySpeed) || 5000 : 5000;
        var transitionSpeed = scriptTag ? parseInt(scriptTag.dataset.transitionSpeed) || 800 : 800;
        var transitionEffect = scriptTag ? scriptTag.dataset.transitionEffect || 'slide' : 'slide';
        var slidesCount = section.querySelectorAll('.swiper-slide').length;

        // Lazy-load iframes antes de inicializar Swiper
        var iframes = section.querySelectorAll('iframe.vv-hero__video--embed[data-src]');
        iframes.forEach(function(iframe) {
          if('IntersectionObserver' in window){
            var ifObs = new IntersectionObserver(function(entries){
              entries.forEach(function(e){ 
                if(e.isIntersecting){ 
                  if(!iframe.src) iframe.src = iframe.dataset.src; 
                  ifObs.disconnect(); 
                } 
              });
            });
            ifObs.observe(iframe);
          } else {
            // Fallback inmediato
            iframe.src = iframe.dataset.src;
          }
        });

        // Configuración de Swiper
        var swiperConfig = {
          loop: slidesCount > 1,
          speed: transitionSpeed,
          effect: transitionEffect,
          
          // Keyboard navigation
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },

          // Touch gestures
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,

          // Eventos
          on: {
            slideChange: function () {
              // Reiniciar animaciones en cada cambio de slide
              var activeSlide = this.slides[this.activeIndex];
              if (activeSlide) {
                var content = activeSlide.querySelector('.vv-hero__content');
                if (content) {
                  content.style.animation = 'none';
                  content.offsetHeight; // Trigger reflow
                  content.style.animation = null;
                }
              }
            },
            init: function() {
              // Aplicar animaciones al slide inicial
              var activeSlide = this.slides[this.activeIndex];
              if (activeSlide) {
                var content = activeSlide.querySelector('.vv-hero__content');
                if (content) {
                  content.style.animation = null;
                }
              }
            }
          }
        };

        // Autoplay solo si hay más de 1 slide y está habilitado
        if (slidesCount > 1 && autoplay) {
          swiperConfig.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        // Navegación solo si hay más de 1 slide
        if (slidesCount > 1) {
          swiperConfig.navigation = {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
          };

          swiperConfig.pagination = {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: true,
          };
        }

        // Configuraciones específicas por efecto
        switch(transitionEffect) {
          case 'fade':
            swiperConfig.fadeEffect = { crossFade: true };
            break;
          case 'cube':
            swiperConfig.cubeEffect = {
              shadow: true,
              slideShadows: true,
              shadowOffset: 20,
              shadowScale: 0.94,
            };
            break;
          case 'flip':
            swiperConfig.flipEffect = {
              slideShadows: true,
              limitRotation: true,
            };
            break;
        }

        // Breakpoints responsive
        swiperConfig.breakpoints = {
          640: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 1 },
        };

        // Inicializar Swiper
        try {
          var swiper = new Swiper(swiperContainer, swiperConfig);
          
          // Guardar referencia para uso posterior
          swiperContainer._swiperInstance = swiper;
          
          // Debug log
          console.log('Viverdez Hero Swiper initialized:', sectionId, {
            slides: slidesCount,
            autoplay: autoplay,
            effect: transitionEffect
          });

        } catch (error) {
          console.error('Error initializing Viverdez Hero Swiper:', error);
        }
      });
    }

    // Inicializar después de un pequeño delay para asegurar que todo esté listo
    setTimeout(initializeSwiper, 100);
  });

  // Funciones globales para control desde el admin si es necesario
  window.ViverdezHero = {
    reinitialize: function() {
      document.querySelectorAll('.vv-hero-swiper').forEach(function(container) {
        if (container._swiperInstance) {
          container._swiperInstance.destroy(true, true);
        }
      });
      setTimeout(function() {
        if (typeof onReady === 'function') onReady();
      }, 100);
    }
  };
})();
